import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useQuest } from '../lib/store.tsx';
import { SettingsSheet } from './SettingsSheet.tsx';

export function TopBar({ back }: { back?: string }) {
  const { online, pendingCount, quest, event } = useQuest();
  const [open, setOpen] = useState(false);
  return (
    <>
      <header className="topbar">
        {back ? (
          <Link to={back} className="icon-btn" aria-label="Back">
            ←
          </Link>
        ) : null}
        <Link to="/" className="brandmark" aria-label={`${event.defenderTitle} — start`}>
          <span className="slash">/</span>{event.defenderTitle}
        </Link>
        <span className="spacer" />
        {quest.dev && !quest.hideDevBanner && <span className="chip warn" title="In-memory development backend">DEV</span>}
        {!online ? (
          <span className="chip warn" role="status">Offline{pendingCount ? ` · ${pendingCount} to sync` : ''}</span>
        ) : pendingCount ? (
          <span className="chip" role="status">Syncing…</span>
        ) : null}
        <button className="icon-btn" onClick={() => setOpen(true)} aria-label="Settings: sound, motion, accessibility">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true"><path d="M3 6h14M3 14h14" /><circle cx="7" cy="6" r="2" fill="var(--panel)" /><circle cx="13" cy="14" r="2" fill="var(--panel)" /></svg>
        </button>
      </header>
      {open && <SettingsSheet onClose={() => setOpen(false)} />}
    </>
  );
}

export function Footer() {
  return (
    <footer className="footer">
      TRUST DOCKER FOR THE AGENTS YOU DON'T | &copy; 2026 Docker
    </footer>
  );
}
